import { useParams } from "react-router-dom";
import VideoPlayer from "../components/VideoPlayer";
import { useEffect, useState } from "react";

export default function Movie() {
  const { mov } = useParams();
  const [link, setLink] = useState('')

  useEffect(() => {
    switch (mov) {
      case 'inicia': setLink('https://nataliabarrera.com/media/videos/Bathos_Inicia.mp4'); break;
      case 'frecuencia': setLink('https://nataliabarrera.com/media/videos/Frequencia.mp4'); break;
      default: setLink('https://nataliabarrera.com/media/videos/Peli_Bathos.mp4'); break;
    }
  }, [mov]);
  
  return (
    <VideoPlayer url={link} muted={false} />
  );
}